import styled from 'styled-components'

export const ChooseIconsWrapperContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(40px, 1fr));
  grid-row-gap: 30px;
  grid-column-gap: 30px;
`
